/* global angular */

var ngModule = angular.module('trends');
var $ = jQuery;

ngModule.directive('paperCollapse', ['Input', 'TagManager',
    function (Input, TagManager) {
        return {
            restrict: 'AC',
            scope: true,
            link: function (scope, element, attrs) {
                var wrapper = element.find('.collapse-card__body-wrapper');
                var heading = element.find('.collapse-card__heading');
                var headingTopOffset = heading.offset().top;
                var body = element.find('.collapse-card__body');
                var toggler = element.find('.collapse-card__toggler');
                var collapseHeight = attrs.closedHeight;
                if (collapseHeight === undefined) {
                    collapseHeight = 0;
                }

                var setActive = function (newState, duration) {
                    scope.active = newState;

                    var actualHeight = body.outerHeight(true);
                    var opts = {queue: false, duration: duration};

                    // Two things here:
                    // a. set `height` to an absolute value during the animation to prevent reflows in Firefox
                    // b. remove `max-height` when not animating, so that the content may grow freely
                    body.height(actualHeight);

                    if (newState) {
                        opts.complete = function () {
                            wrapper.css('max-height', '');
                            body.height('auto');
                            body.find('.add-to-pptbuilder').css('display', '');
                        };
                    } else {
                        if (wrapper.height() >= (actualHeight | 0)) {
                            wrapper.css('max-height', actualHeight);
                        }
                        if ($(window).scrollTop() > headingTopOffset) {
                            $('html, body').animate({
                                scrollTop: heading.offset().top
                            }, 400);
                        }
                        opts.complete = function () {
                            body.find('.add-to-pptbuilder').css('display', 'none');
                            body.height('');
                        };
                    }

                    // Browsers can't transition `height: 0 -> height: auto` so we use max-height instead
                    wrapper.animate({maxHeight: newState ? actualHeight : collapseHeight}, opts);
                };

                setActive(false, 0);

                var analyticsEmitted = false;
                Input.addAccessibleClickHandler(toggler, function () {
                    scope.$apply(function () {
                        setActive(!scope.active, 400);

                        // Emit analytics event
                        if (!analyticsEmitted) {
                            analyticsEmitted = true;
                            TagManager.event(attrs.paperCollapseAnalytics || 'collapse-toggle');
                        }
                    });
                });
            }
        };
    }]);
